import React, { useState, useEffect } from "react";

export const svg = `<svg viewBox="0 0 28 28"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 4h-11A2.5 2.5 0 0 0 6 6.5v8.974a1 1 0 0 0 .433.824l7 4.813a1 1 0 0 0 1.133 0l7-4.813a1 1 0 0 0 .434-.824V6.5A2.5 2.5 0 0 0 19.5 4ZM6 17.82v1.203c0 .494.243.957.65 1.236l6.5 4.47a1.5 1.5 0 0 0 1.7 0l6.5-4.47a1.5 1.5 0 0 0 .65-1.236V17.82l-7.264 4.994a1.3 1.3 0 0 1-1.473 0L6 17.82Zm7.846-3.884a.332.332 0 0 1 .308 0l1.96 1.026a.332.332 0 0 0 .48-.35l-.373-2.17a.332.332 0 0 1 .096-.295l1.582-1.536a.332.332 0 0 0-.184-.567l-2.188-.316a.332.332 0 0 1-.25-.182l-.98-1.977a.332.332 0 0 0-.595 0l-.98 1.977a.332.332 0 0 1-.25.182l-2.187.316a.332.332 0 0 0-.184.567l1.582 1.536a.332.332 0 0 1 .096.295l-.374 2.17a.332.332 0 0 0 .482.35l1.959-1.026Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
